import { SxProps, styled, Theme } from '@mui/material/styles';
import { ImgHTMLAttributes } from 'react';

export type Props = ImgHTMLAttributes<HTMLImageElement> & {
  rounded?: boolean;
  sx?: SxProps<Theme>;
};

const Root = styled('img', {
  shouldForwardProp: (prop) => prop !== 'rounded' && prop !== 'sx',
})<Props>(({ theme, rounded }) => {
  const numericRadius =
    typeof theme.shape.borderRadius === 'number'
      ? theme.shape.borderRadius
      : Number.parseFloat(theme.shape.borderRadius);
  const baseRadius = Number.isFinite(numericRadius) ? numericRadius : 0;

  return {
    borderRadius: rounded ? baseRadius * 2 : 'initial',
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  };
});
export const Image = (props: Props) => {
  return <Root loading="lazy" {...props} />;
};
